<template>
  <div class="page-bind-mobile">
    <form class="form"
          @submit.prevent="handleSubmit">
      <div class="form-fields">
        <ym-field class="ym-field"
                  v-model.trim="mobile"
                  type="tel"
                  placeholder="输入手机号"
                  :attr="{ autocomplete: false }"
                  @keyup.enter.prevent="handleSubmit"
        />
        <ym-field class="ym-field"
                  v-model.trim="smsCode"
                  placeholder="输入验证码"
                  :attr="{ autocomplete: false }"
                  @keyup.enter.prevent="handleSubmit"
        >
          <ym-button class="sms-btn"
                     plain
                     type="primary"
                     size="small"
                     :disabled="disabledSmsCode"
                     @click.prevent="handleClickSendSmsCode"
          >{{ smsCodeText }}
          </ym-button>
        </ym-field>
      </div>
      <div class="form-bottom">
        <ym-button class="submit-btn"
                   size="large"
                   type="primary"
                   :disabled="disabled"
                   @click.prevent="handleSubmit"
        >确认
        </ym-button>
      </div>
    </form>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import { Field, Button, Toast } from 'ym-mint-ui';
  import { sendSmsCode } from '@/services/user';
  import validator from '@/utils/validator';
  import { getQuery } from '@/utils';
  import { SMS_CODE_DURATION } from '@/utils/constant';
  import { lotteryJoin } from '@/services/tour-lottery';

  export default {
    name: 'PageBindMobile',
    components: {
      'ym-field': Field,
      'ym-button': Button,
    },
    data() {
      return {
        mobile: '',
        smsCode: '',
        smsCodeDisabled: false,
        smsCodeText: '获取验证码',
        submitDisabled: false,
      };
    },
    computed: {
      query() {
        return getQuery(this.$route.query);
      },
      disabledSmsCode() {
        return this.mobile === '' || this.smsCodeDisabled;
      },
      disabled() {
        return this.mobile === ''
          || this.smsCode === ''
          || this.submitDisabled;
      },
    },
    watch: {
      mobile(val) {
        if (!validator.isMobile(val)) {
          this.smsCodeDisabled = true;
          return;
        }
        this.smsCodeDisabled = false;
      },
    },
    methods: {
      ...mapActions([
        'BindMobile',
      ]),
      async handleClickSendSmsCode() {
        if (!validator.isMobile(this.mobile)) {
          Toast('请输入正确的手机号');
          return;
        }
        try {
          await sendSmsCode(this.mobile, 'sms_bind');
          this.smsCodeDisabled = true;
          let duration = SMS_CODE_DURATION;
          const t = setInterval(() => {
            if (duration <= 0) {
              this.smsCodeText = '重新获取';
              this.smsCodeDisabled = false;
              clearInterval(t);
              return;
            }
            this.smsCodeText = `已发送(${duration}s)`;
            duration -= 1;
          }, 1000);
        } catch (e) {
          this.smsCodeDisabled = false;
        }
      },
      async handleSubmit() {
        if (!validator.isMobile(this.mobile)) {
          Toast('请填写正确的手机号');
          return;
        }
        if (validator.isEmpty(this.smsCode)) {
          Toast('请填写验证码');
          return;
        }
        this.submitDisabled = true;
        try {
          await lotteryJoin({
            mobile: this.mobile,
            sms_code: this.smsCode,
            sme_type: 'sms_bind',
          });
          window.location.reload();
        } catch (e) {
          this.submitDisabled = false;
        }
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-bind-mobile {
    height: 100%;
    padding-top: @size-base;
    box-sizing: border-box;
    background-color: @color-white;
  }

  .form {
    padding: 0 @form-page-padding;
  }

  .ym-field {
    font-size: @font-size-medium;
    /deep/ .mint-field-other {
      display: flex;
      align-items: center;
    }
  }

  .sms-btn {
    border-radius: @border-radius-normal;
    font-size: @font-size-base;
    padding: 0 @size-small;
  }

  .submit-btn {
    margin: @size-medium auto @size-base;
  }

  .user-term {
    font-size: @font-size-small;
    color: @color-text-lighter;
  }

  .link {
    color: @color-link;
  }
</style>
